import { render } from "./Alerts.vue?vue&type=template&id=46f6506c"
import script from "./Alerts.vue?vue&type=script&setup=true&lang=js"
export * from "./Alerts.vue?vue&type=script&setup=true&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=46f6506c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/alerts/Alerts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46f6506c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46f6506c', __exports__)) {
    api.reload('46f6506c', __exports__)
  }
  
  module.hot.accept("./Alerts.vue?vue&type=template&id=46f6506c", () => {
    api.rerender('46f6506c', render)
  })

}


export default __exports__